import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import FunctionGeneral from '../functionsGeneral';
import { getFlagDisplay } from '../helpers/flagDisplayHelper';
import { ProductBoxId } from 'enums/ProductEnum';

function DetalleContratoTableVencimiento(props) {
    const [data] = useState(props.data);
    const [IndiceRowDetalle, setIndiceRowDetalle] = useState(
        props.IndiceRowDetalle
    );
    const [positionDetails, setPositionDetails] = useState(
        window.scrollY > 400 ? 60 + window.scrollY - 400 + 'px' : '60px'
    );
    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    useEffect(() => {
        setIndiceRowDetalle(props.IndiceRowDetalle);
    }, [props.IndiceRowDetalle]);

    const handleScroll = () => {
        if (window.scrollY > 400)
            setPositionDetails(window.scrollY - 400 + 'px');
        else setPositionDetails(60);
    };

    function setindiceNew() {
        props.setIndiceRowDetalle(-1);
        props.setIndiceRow(props.IndiceRowDetalle);
    }

    const showRecompraIrrevocable = productBoxId =>
        [
            ProductBoxId.NEXT,
            ProductBoxId.CPC,
            ProductBoxId.RENTING,
            ProductBoxId.AUTOCREDIT,
        ].includes(productBoxId);
    return (
        <div className={'containerInfoTable'}>
            <div className="displayInfor" style={{ top: positionDetails }}>
                <div className="o-layout__item u-12/12">
                    <button
                        className="c-modal__close-btn u-text-right"
                        onClick={() => props.setIndiceRowDetalle(-1)}
                    ></button>
                </div>
                <div className="u-11/12">
                    <button
                        className="c-btn c-btn--secondary c-btn--icon"
                        style={{ marginBottom: '20px' }}
                        onClick={() => setindiceNew(props.IndiceRowDetalle)}
                    >
                        <i
                            className="c-btn__icon c-icon  c-icon--[control-eye]"
                            aria-hidden="true"
                            role="img"
                        ></i>
                        <span className="c-btn__text">FICHA CLIENTE</span>
                    </button>
                    <label className="labelConsT u-text-base u-1/1">
                        Vehículo
                    </label>
                    {data[IndiceRowDetalle].VehiclePlate !== null && (
                        <label className="labelConsT u-text-muted u-1/1">
                            {data[IndiceRowDetalle].VehiclePlate}
                        </label>
                    )}
                    {data[IndiceRowDetalle].TMAIMG !== null && (
                        <label className="labelConsT u-text-muted u-1/1">
                            {data[IndiceRowDetalle].TMAIMG}
                        </label>
                    )}
                    {data[IndiceRowDetalle].VehicleModelDescription !==
                        null && (
                            <label className="labelConsT u-text-muted u-1/1">
                                {new FunctionGeneral().capitalizeText(
                                    data[
                                        IndiceRowDetalle
                                    ].VehicleModelDescription.split(' ')
                                )}
                            </label>
                        )}
                    {data[IndiceRowDetalle].VehicleIdentificationNumber !==
                        null && (
                            <label className="labelConsT u-text-muted u-1/1">
                                {data[IndiceRowDetalle].VehicleIdentificationNumber}
                            </label>
                        )}

                    <label className="labelConsT u-text-base u-1/1">
                        Cliente
                    </label>
                    {data[IndiceRowDetalle].TitularNIF !== null && (
                        <label className="labelConsT u-text-muted u-1/1">
                            {data[IndiceRowDetalle].TitularNIF}
                        </label>
                    )}
                    {data[IndiceRowDetalle].TitularFullName !== null && (
                        <label className="labelConsT u-text-muted u-1/1 u-text-capitalize">
                            {new FunctionGeneral().capitalizeText(
                                data[IndiceRowDetalle].TitularFullName.split(
                                    ' '
                                )
                            )}
                        </label>
                    )}

                    {showRecompraIrrevocable(data[IndiceRowDetalle].ProductBoxId) && (
                        <label className="labelConsT u-text-base u-1/1">
                            Recompra Irrevocable
                        </label>
                    )}
                 
                    {showRecompraIrrevocable(data[IndiceRowDetalle].ProductBoxId) && (
                        <label className="labelConsT u-text-muted u-1/1">
                            {getFlagDisplay(data[IndiceRowDetalle].Flag).label}
                        </label>
                    )}

                    {data[IndiceRowDetalle].IPODate !== null && (
                        <label className="labelConsT u-text-base u-1/1">
                            Fecha Ipo
                        </label>
                    )}
                    {data[IndiceRowDetalle].IPODate !== null && (
                        <label className="labelConsT u-text-muted u-1/1">
                            {data[IndiceRowDetalle].IPODate}
                        </label>
                    )}
                    <label className="labelConsT u-text-base u-1/1">
                        Fecha de Vencimiento
                    </label>
                    {data[IndiceRowDetalle].ExpirationDate !== null && (
                        <label className="labelConsT u-text-muted u-1/1">
                            {data[IndiceRowDetalle].ExpirationDate}
                        </label>
                    )}

                    <label className="labelConsT u-text-base u-1/1">
                        Asesor original
                    </label>
                    {data[IndiceRowDetalle].SellerContractsFullName !==
                        null && (
                            <label className="labelConsT u-text-muted u-1/1 u-text-capitalize">
                                {new FunctionGeneral().capitalizeText(
                                    data[
                                        IndiceRowDetalle
                                    ].SellerContractsFullName.split(' ')
                                )}
                            </label>
                        )}
                    <label className="labelConsT u-text-base u-1/1">
                        Operación
                    </label>
                    {data[IndiceRowDetalle].FinancialOperationCode !== null && (
                        <label className="labelConsT u-text-muted u-1/1 u-pb-small">
                            {data[IndiceRowDetalle].FinancialOperationCode}
                        </label>
                    )}
                </div>
                <div className="u-1/12" />
            </div>
        </div>
    );
}

export default withRouter(DetalleContratoTableVencimiento);
